import React from "react";
import { UserProvider } from "./context/UserContext";
import { AuthProvider } from "./context/AuthContext";
import { PreBoardingProvider } from "./context/PreBoardingContext";
import { TenantProvider, useTenant } from "./context/TenantContext";
import AppRoutes from "./routes/AppRoutes";
import UpdateNotification from "./components/UpdateNotification";
import { useAppUpdate } from "./hooks/useAppUpdate";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Inner component to use the update hook
const AppContent = () => {
  const { isUnknownTenant } = useTenant();
  useAppUpdate();

  if (isUnknownTenant) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.25rem",
          fontWeight: 600,
        }}
      >
        Tenant not found
      </div>
    );
  }

  return (
    <>
      <UpdateNotification />
      <AppRoutes />
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

const App = () => {
  return (
    <TenantProvider>
      <AuthProvider>
        <UserProvider>
          <PreBoardingProvider>
            <AppContent />
          </PreBoardingProvider>
        </UserProvider>
      </AuthProvider>
    </TenantProvider>
  );
};

export default App;
